export enum Routes {
	Home = '/home',

	// header
	Header = '/header',
	EmailSent = '/email-sent',

	//authentication
	Login = '/',
	Signup = '/signup',
	RestPassword = '/reset-password',

	// details
	AdminViewUserProfile = '/profile/:username',

	//menu
	Menu = '/menu',

	//messages
	Welcome = '/welcome',
	YourDetails = '/your-details',
	AddDetails = '/add-details',
	Address = '/address/:id',
	Congratulations = '/congratulations/:id',
	PremiumCongratulations = '/premium-congratulations/:id',
	PaymentInformation = '/payment-information/:id',
	PremiumInformation = '/premium-payment/:id',
	Upgrade = '/upgrade/:id',

	//Categories and Membership
	Membership = '/membership/:id',
	Categories = '/categories',

	Notification = '/Notification',
	Calendar = '/calendar/:id',
	ExerciseHome = '/dev-categories',
	ListExerciseDetails = '/exercise/:id',
	Options = '/options/:id',
	Skills = '/skills',
	UpcomingMilestones = '/upcoming-milestones/:id',
	Checkouts = '/checkouts',
	Process = '/timelines',
	ListAllExercises = '/all-exercises',
	ExerciseDetails = '/upcoming-milestones/exercises/:categoryId&:id',

	MilestoneCategories = '/milestoneCategories',
	MilestoneListByCategories = '/milestones/:id',
	MilestoneDetails = '/milestone/:id',
	milestoneAchieved = '/milestoneAchieved/:id',

	ListAllResources = '/resources-categories',
	ResourceDetails = '/resourceCategory/:id',
	forgotPassword = '/forgotPassword',
	newPassword = '/newPassword/:token',
	generateNewToy = '/generate-toy/:id',
	new = '/new',
	EmailActivated = '/verification/:token',

	// template
	Temp = '/temp',

	// gift membership
	GiftMembership = '/gift-membership/:activationCode',
	GiftCardActivate = '/ActivateWithGiftCard/:token',

	// admin site configs
	AdminLogin = '/admin-login',
	AdminHome = '/admin-home',
	boxes = '/boxes/:id',
}
